(function () {
  'use strict';

  angular
    .module('ModalEventos', ['ModuleMapasUtil', 'ui.bootstrap']);
}());
